import React from 'react';
import _ from 'lodash';
import InputFields from '../../components/common/InputFields';
import CheckboxComponent from '../../components/common/CheckBox';
import SearchableDropdownComponent from '../../components/common/SearchableDropDown';
import ToggleComponent from '../../components/common/Toggle';
import InputWithLabel from '../../components/common/InputwithLabel';
import SelectionItemDropDown from '../../components/common/SelectionItemDropDown';
import RadioButtonComponent from '../../components/common/Radios';
import InputHPRABHAVerify from '../../components/common/InputFieldsUserHPRABHAVerification/index';
import VillagesMapped from '@pages/GeoNonGeo/components/VillagesMapped';
import TextArea from '@components/common/TextArea';
import AntDateFieldsComponent from '@components/common/AntDatePickerFields';
import Button from '@components/common/Button';
import InputFieldWithCreateAndVerify from '@components/common/InputFieldWithCreateAndVerify';
import ToggleButton from '@pages/Beneficiary-block/WomenComponent/Child/Toggle';
import PasswordInput from '@components/common/PasswordInputField';
import RadioButton from '@components/common/RadioButton';
import CommonTimePicker from '@components/common/TimePicker';
import InputFieldWithSuffix from '@components/common/InputFieldWithSuffix';
import Slider from '@components/common/Slider';


interface formDataType {
    [key: string]: any;
}

interface OptionType {
    label: string;
    value: string;
    code: string;
}

type propsType = {
    formData: formDataType;
    handleFormChange: (
        value: string | boolean | OptionType | any,
        key: string,
        field?: formDataType,
        option?: any,
        code?: any,
        id?: any,
        changedData?:any,
    ) => void;
    onInputChange?: (value:string, key:string) => any;
    formState: formDataType;
    verified?: any;
    savedItems?: any;
    onClickVerify?: (value: boolean) => void
    onDropDownClick?: (key: string) => void
    message?: string;
    onInputFieldEditIconClick?:any;
    forceDistrictEnabled?: boolean;
};

const CommonFormFields = ({
    formData,
    handleFormChange,
    onInputChange,
    formState,
    verified,
    message,
    savedItems,
    onClickVerify,
    onDropDownClick = () => { },
    onInputFieldEditIconClick,
    forceDistrictEnabled = false,
}: propsType) => {

    const formKeys = Object?.keys(formData) as (keyof formDataType)[];
    return (
        <>
            {formKeys.map((element: any) => {
                const field: formDataType = formData[element];
                const fieldType = field['#type'];
                const title = field['#title'];
                const key: string = field['#webform_key'];
                const isDisabled: boolean = field['#isDisabled'];
                const showSelectedOption: boolean = field['#showSelectedOption'];
                const isBtnDisabled: boolean = field['#isBtnDisabled'];
                const suffix: string = field['#suffix'];
                const showCheckMark: boolean = field['#showCheckMark'];
                const showPlaceholder: boolean = field['#showPlaceholder'];
                const isMultiDropdown: boolean = field['#multiDropdown'];
                const isGroup = field['#group'];
                const dateMinimum = field['#dateMinimum'];
                const minDate = field['#minDate'];
                const maxDate = field['#maxDate'];
                const showTime = field['#showTime'] ? field['#showTime'] : false;
                const showDateTimeFormat = field['#showDateTimeFormat'] ? field['#showDateTimeFormat'] : false;
                const showOnlyTime = field['#showOnlyTime'] ? field['#showOnlyTime'] : false;
                const isRequired = field['#required'] && field['#required'] === true ? true : false;
                const isMotherAlive = field['#isMotherAlive'];
                const tooltipNeeded = field['#tooltipNeeded'];
                const tooltipText = field['#tooltipText'];
                const isVisible = field['#isVisible'];
                const id = field['#id'];
                const flow = field['#flow'];
                const minTime = field['#minTime'];
                const maxTime = field['#maxTime'];
                const minSliderValue = field['#min'];
                const defaultSliderValue = field['#default'];
                const maxSliderValue = field['#max'];
                const smallSliderStep = field['#smallStep'];
                const largeSliderStep = field['#largeStep'];
                const isCurrentTime = field['#isCurrentTime'];
                const timeFormat = field['#timeFormat'];
                const disableIndividualDates = field['#individualDates'] ? field['#individualDates'] : [];
                const useRelativePopup = field['#useRelativePopup'] ? field['#useRelativePopup'] : false;
                const isAllOptionRequired = field['#isAllOptionRequired'] ? field['#isAllOptionRequired'] : false;  
                const showEditIconInInputField=field['#showEditIconInInputField'] ? field['#showEditIconInInputField'] : false;
                const placeHolder=field['#placeHolder'] ? field['#placeHolder'] : null;
                const customClassName = field['#className'];
                if (fieldType === 'select') {
                    const dataOptions = field['#options'];
                    //const options;
                    // const options2: string[] = dataOptions
                    //     ? Object.values(dataOptions)
                    //     : [];
                    // options = options2.map((option1: any) => ({
                    //     value: option1,
                    //     label: option1,
                    // }));
                    const value = isMultiDropdown ? formState[key].value && formState[key].value.map((key: string) => ({
                        value: key,
                        label: key,
                    })) : formState[key]?.value ? {
                        value: formState[key].value,
                        label: formState[key].value,
                    } : ''
                    const resolvedIsDisabled = key === 'district' && forceDistrictEnabled ? false : isDisabled;
                    return (
                        <div key={key} className={`${key}_wrapper ${isVisible?'showDropdown':'hideDropdown'}`} >
                            <SearchableDropdownComponent
                                options={dataOptions}
                                onChange={(changedData: any) => handleFormChange(isMultiDropdown ? changedData : changedData?.value, key, changedData?.id, dataOptions, changedData?.code, changedData)}
                                onInputChange={(inputData:any)=> onInputChange && onInputChange(inputData, key)}                
                                placeHolder={showPlaceholder ? 'Start typing minimum 3 characters to search' : title}
                                multipleSelection={isMultiDropdown ? isMultiDropdown : false}
                                dropDownType={formState[key]?.isError ? 'error' : 'general'}
                                dropLabelName={title}
                                ifRequired={isRequired}
                                dropDownDisable={resolvedIsDisabled}
                                dropdownsearchable={true}
                                value={value}
                                errorMessage={formState[key]?.message}
                                isClearable={true}
                                showSelectedOption={showSelectedOption}
                                tooltipNeeded={tooltipNeeded}
                                toolTipText={tooltipText}
                                isAllOptionRequired={isAllOptionRequired}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'textfield') {
                    return (
                        <div key={key} className={`${key}_wrapper ${isVisible?'showDropdown':'hideDropdown'}`}>
                            <InputFields
                                placeholder={placeHolder ?? title}
                                className={customClassName || key}
                                onChange={(changedData, e) => {
                                    if (key === 'mob' && changedData !== "" && !Number(changedData)) {
                                        e.preventDefault();
                                        return false;
                                    }
                                    handleFormChange(changedData, key);
                                }}

                                labelName={title}
                                isDisabled={isDisabled}
                                type="text"
                                required={isRequired || false}
                                value={formState[key]?.value ?? ''}
                                inputType={formState[key]?.isError ? 'error' : 'general'}
                                errorMessage={formState[key]?.message}
                                showEditIcon={showEditIconInInputField}
                                onInputFieldEditIconClick={onInputFieldEditIconClick}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'InputFieldWithSuffix') {
                    return (
                        <div key={key} className={`${key}_wrapper ${isVisible?'showDropdown':'hideDropdown'}`}>
                            <InputFieldWithSuffix
                                placeholder={title}
                                className={key}
                                labelName={title}
                                type="text"
                                disabled={isDisabled}
                                btnDisabled={isBtnDisabled}
                                required={isRequired}
                                value={formState[key].value}
                                suffix={suffix}
                                showButton={true}
                                showCheckMark={showCheckMark}
                                onChange={(changedData) => {
                                    handleFormChange(changedData, key);
                                }}
                                inputType={formState[key]?.isError ? 'error' : 'general'}
                                errorMessage={formState[key]?.message}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'textArea') {
                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            <TextArea
                                placeholder={title}
                                className={key}
                                onChange={(changedData) => {
                                    handleFormChange(changedData, key);
                                }}
                                labelName={title}
                                isDisabled={false}
                                type="text"
                                required={isRequired || false}
                                value={formState[key].value}
                                errorMessage={formState[key]?.message}
                                inputType={formState[key]?.isError ? 'error' : 'general'} />
                        </div>
                    )
                }
                else if (fieldType === 'date') {
                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            <AntDateFieldsComponent
                                placeholder={title}
                                className={key}
                                onChange={(changedData) => handleFormChange(changedData, key)}
                                labelName={title}
                                isDisabled={isDisabled}
                                type="date"
                                required={isRequired || false}
                                value={formState[key].value}
                                inputType={formState[key].isError ? 'error' : 'general'}
                                errorMessage={formState[key].message}
                                disablePastDates={dateMinimum}
                                minDate={minDate}
                                maxDate={maxDate}
                                showTime={showTime}
                                showDateTimeFormat={showDateTimeFormat}
                                showOnlyTime={showOnlyTime}
                                disableIndividualDates={disableIndividualDates}
                                useRelativePopup={useRelativePopup}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'number') {
                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            <InputFields
                                placeholder={title}
                                className={key}
                                onChange={(changedData) => handleFormChange(changedData, key)}
                                labelName={title}
                                isDisabled={isDisabled}
                                type="number"
                                required={isRequired || false}
                                value={
                                    formState[key].value}
                                inputType={formState[key].isError ? 'error' : 'general'}
                                errorMessage={formState[key].message}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'verify') {

                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            <InputWithLabel
                                labelName={title}
                                inputwithlabelPlaceholder={title}
                                inputlabelPlaceholder={'Verified'}
                                inputlabeltype="text"
                                disabled={isDisabled}
                                verified={verified}
                                onChange={(changedData) => handleFormChange(changedData, key)}
                                inputlabelvalue={formState[key]?.value}
                                inputType={formState[key]?.isError ? 'error' : 'general'}
                                errorMessage={formState[key]?.message}
                                verifyMessage={message}
                                onClickVerify={verified[key] ? onClickVerify || function (value: boolean): void {
                                    value = true;
                                } : onClickVerify || function (value: boolean): void {
                                    value = true;
                                }}
                                value={formState[key]?.value}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'verifyHPR') {

                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            <InputHPRABHAVerify
                                labelName={title}
                                inputwithlabelPlaceholder={title}
                                inputlabelPlaceholder={'Verified'}
                                inputlabeltype="text"
                                disabled={isDisabled}
                                verified={verified}
                                onChange={(changedData) => handleFormChange(changedData, key)}
                                inputlabelvalue={formState[key]?.value}
                                inputType={formState[key]?.isError ? 'error' : 'general'}
                                errorMessage={formState[key]?.message}
                                verifyMessage={message}
                                onClickVerify={verified[key] ? onClickVerify || function (value: boolean): void {
                                    value = true;
                                } : onClickVerify || function (value: boolean): void {
                                    value = true;
                                }}
                                value={formState[key]?.value}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'radios') {
                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            < RadioButtonComponent
                                radioName={title}
                                radioButtonGroup={isGroup}
                                disabled={isDisabled}
                                onRadioButtonChange={(changedData) => handleFormChange(changedData, key)}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'radioButton') {
                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            < RadioButton
                                radioName={title}
                                radioButtonGroup={isGroup}
                                disabled={isDisabled}
                                defaultChecked={formState[key].value}
                                onRadioButtonChange={(changedData) => handleFormChange(changedData, key)}
                                option={field['#options']}
                                inputType={formState[key]?.isError ? 'error' : 'general'}
                                errorMessage={formState[key]?.message}
                                required={isRequired}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'checkbox') {
                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            <CheckboxComponent
                                className={isVisible === 'isVisible' ? 'show_checkbox' : (isVisible === 'isNotVisible' ? 'hide_checkbox' : '')}
                                placeCheckboxBefore={false}
                                isChecked={formState[key]?.value}
                                checkBoxName={title}
                                disabled={isDisabled === true ? true : false || false}
                                onCheckboxChange={(changedData) => handleFormChange(changedData, key)}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'toggle') {
                    const dataOptions = field['#options'];
                    const options: string[] = dataOptions
                        ? Object.values(dataOptions)
                        : [];
                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            <ToggleComponent
                                onToggleChange={(changedData) =>
                                    handleFormChange(changedData, key)
                                }
                                switchName={title}
                                Disabled={isDisabled}
                                switchId=""
                                checked={formState[key]?.value}
                                switchOnOffNames={options}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'checkboxes') {
                    const checkboxOptions = field['#options'];
                    if (!_.isEmpty(checkboxOptions)) {
                        return _.keys(checkboxOptions).map((option) => {
                            const optionsKey = checkboxOptions[option];
                            const removeSpecialChar = option.replace(/[\s?]/g, '_');
                            return (
                                <div key={option} className={`${removeSpecialChar}_wrapper`}>
                                    <CheckboxComponent
                                        className={optionsKey}
                                        placeCheckboxBefore={false}
                                        isChecked={formState[optionsKey]?.value}
                                        checkBoxName={optionsKey}
                                        disabled={false}
                                        onCheckboxChange={(changedData: boolean) => {
                                            handleFormChange(changedData, optionsKey);
                                        }}
                                    />
                                </div>
                            );
                        });
                    }
                    return;
                }
                else if (fieldType === 'selectionDropdown') {
                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            <SelectionItemDropDown
                                dropDownClick={() => onDropDownClick(key)}
                                placeHolder={title}
                                multipleSelection={true}
                                dropDownType={formState[key]?.isError ? 'error' : 'general'}
                                dropLabelName={title}
                                ifRequired={isRequired}
                                dropDownDisable={true}
                                dropdownsearchable={true}
                                savedItems={savedItems[key]}
                                errorMessage={formState[key]?.message}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'webform_section') {
                    
                    return (
                        <>
                            <CommonFormFields
                                formData={field}
                                handleFormChange={handleFormChange}
                                formState={formState}
                            />
                            <div className={`hr1-form-${key}`}></div>
                        </>
                    );
                }
                else if (fieldType === "selectionModal") {
                    return <div key="showModal">
                        <VillagesMapped labelName={title}
                            formData={title === "Villages Mapped" ? formData['villages_mapped'] : formData['wards_mapped']}
                            formState={title === "Villages Mapped" ? formState['villages_mapped'] : formState['wards_mapped']}
                            isDisabled={isDisabled}
                            allFormState={formState}
                            allFormData={formData}
                        />
                    </div>
                }
                else if (fieldType === 'createAndVerify') {

                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            <InputFieldWithCreateAndVerify
                                labelName={title}
                                inputwithlabelPlaceholder={title}
                                inputlabelPlaceholder={'Verified'}
                                inputlabeltype="text"
                                disabled={isDisabled}
                                id={id}
                                verified={verified}
                                onChange={(changedData, ) => handleFormChange(changedData, key)}
                                inputlabelvalue={formState[key]?.value}
                                inputType={formState[key]?.isError ? 'error' : 'general'}
                                errorMessage={formState[key]?.message}
                                required={isRequired}
                                verifyMessage={message}
                                value={formState[key]?.value}
                                onClickVerify={onClickVerify}
                                flow={flow}
                            />
                        </div>
                    );
                }
                else if (fieldType === "checkboxToggle"){
                    return (
                        <ToggleButton 
                            key={key} 
                            title={title} 
                            handleToggle={handleFormChange} 
                            toggleType='isMotherAlive'
                            isToggled={isMotherAlive}
                        />
                    )
                }
                else if (fieldType === 'password') {
                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            <PasswordInput 
                                label={title} 
                                placeholder={title} 
                                onChange={(changedData) => handleFormChange(changedData, key)} 
                                inputType={formState[key]?.isError ? 'error' : 'general'} 
                                errorMessage={formState[key]?.message} 
                                tooltipNeeded={tooltipNeeded}
                                toolTipText={tooltipText}
                            />
                        </div>
                    );
                }
                else if (fieldType === 'time') {
                    return (
                        <div key={key} className={`${key}_wrapper`} >
                            <CommonTimePicker
                                placeholder={title}
                                className={key}
                                labelName={title}
                                isDisabled={isDisabled}
                                required={isRequired || false}
                                inputType={formState[key].isError ? 'error' : 'general'}
                                errorMessage={formState[key].message}
                                minTime={minTime}
                                maxTime={maxTime}
                                onChange={(changedData:any) => handleFormChange(changedData, key)} 
                                value={formState[key].value}
                                isCurrentTime={isCurrentTime}
                                timeFormat={timeFormat}
                            />
                        </div>
                    )
                }
                else if (fieldType === 'slider') {
                    return (
                        <div key={key} className={`${key}_wrapper`}>
                            <Slider
                                label={title} 
                                onChange={(changedData:number) => handleFormChange(changedData, key)} 
                                min={minSliderValue}
                                max={maxSliderValue}
                                defaultValue = {defaultSliderValue}
                                smallStep={smallSliderStep}
                                largeStep={largeSliderStep}
                                inputType={formState[key]?.isError ? 'error' : 'general'} 
                                errorMessage={formState[key]?.message} 
                                isDisabled={isDisabled}
                                required={isRequired}
                            />
                        </div>
                    );
                }
            })}
        </>
    );
};

export default CommonFormFields;


